import { EmptyListItemContent } from '../EmptyListItemContent'
import { ListItem } from '../ListItem'

import * as styles from './EmptyListItem.module.css'

function EmptyListItem({ className = styles.EmptyListItem, ...restProps }) {
  return (
    <ListItem
      {...restProps}
      Content={EmptyListItemContent}
      className={className}
    />
  )
}

export default EmptyListItem
